/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react';
import { makeStyles, tokens } from '@fluentui/react-components';

export const getFeedbackIconStyle = (useThumbIcons: boolean): IButtonStyles => ({
    root: {
        padding: '0 8px',
        color: useThumbIcons ? tokens.colorNeutralForeground1 : '#FAFAFA',
        selectors: {
            ':hover:enabled': {
                color: useThumbIcons ? tokens.colorNeutralForeground1 : '#FAFAFA',
                border: '1px solid #FFFFFF'
            },
            ':focus:enabled': {
                color: useThumbIcons ? tokens.colorNeutralForeground1 : '#FAFAFA',
                border: '1px solid #FFFFFF'
            },
            ':disabled': {
                background: 'transparent'
            }
        }
    }
});

export const useStyles = makeStyles({
  thumbsButton: {
    '& .fui-Button__icon': {
      color: tokens.colorNeutralForeground3,
    },

    ':hover': {
      '& .fui-Button__icon': {
        color: tokens.colorNeutralForeground2,
      },
    },

    ':hover:active': {
      '& .fui-Button__icon': {
        color: tokens.colorNeutralForeground2Pressed,
      },
    },
  },
});
